
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/class/[slug]/[uid]",
      function () {
        return require("private-next-pages/class/[slug]/[uid].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/class/[slug]/[uid]"])
      });
    }
  